/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable import/prefer-default-export */
import { languageConstants } from '../constants/languageConstants';

function unsetLanguage() {
  return (dispatch, getState) => {
    localStorage.removeItem('language');
    dispatch({ type: languageConstants.UNSET_LANGUAGE });
  };
}

function setLanguage(language) {
  return (dispatch, getState) => {
    localStorage.setItem('language', JSON.stringify(language));
    dispatch({ type: languageConstants.SET_LANGUAGE, language });
  };
}

export const languageActions = {
  unsetLanguage,
  setLanguage,
};
